module.exports = __webpack_public_path__ + "img/wikipedia-w-brands.646ba03e.svg";